import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { setTrim } from '../../../../lib/common';
import RejectRegistrationStoreTag from '../../../../views/brand/common/modal/RejectRegistrationStoreTag';
import withModal from '../../../../lib/hoc/withModal';
import { brandActions } from '../../../../store/modules/brand';

class RejectRegistrationStoreTagModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 상품 태그 거절 사유 타입
      type: 0,
      //--> 상품 태그 거절
      reason: null,
    };
  }

  /**
   * 브랜드 태그 승인 거절하기
   */
  onSubmit = () => {
    const { form, data, rejectRegistrationStoreTag } = this.props;
    const { type, reason } = this.state;
    const { storeId, tagGroupType, tagGroupId } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      rejectRegistrationStoreTag({
        storeId,
        tagGroupType,
        tagGroupId,
        type,
        reason: setTrim(reason),
      });

      /**
       *  모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'rejectRegistrationStoreTagModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <RejectRegistrationStoreTag
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.brand.rejectRegistrationStoreTagModal.isOpen,
    data: state.brand.rejectRegistrationStoreTagModal.data,
  };
};

const mapDispatchToProps = {
  rejectRegistrationStoreTag: brandActions.rejectRegistrationStoreTag,
  toggleModal: brandActions.toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(RejectRegistrationStoreTagModalContainer)));
